import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ObjectLookupComponent } from './object-lookup.component';
import { CurrencyService } from 'app/server/server.module';

@Component({
  selector: 'app-currency-object-lookup',
  templateUrl: './currency-object-lookup.component.html',
  styleUrls: ['./object-lookup.component.scss']
})
export class CurrencyObjectLookupComponent extends ObjectLookupComponent {
  constructor(private currencyService: CurrencyService) {
    super();
  }

  protected loadObjectByIdFromService(id: number) {
    this.currencyService.getCurrency(id);
    this.currencyService.currency$.pipe(catchError(() => of(null))).subscribe((result: any) => {
      this.isLoadingObject = false;
      if (result) {
        this.selectedObject = result;
        this.searchTerm = this.getObjectName(result);
        this.isSearching = false;
      } else {
        this.selectedObject = null;
        this.searchResults = [];
        this.searchTerm = '';
        this.isSearching = true;
      }
    });
  }

  public getObjectType(): string {
    return 'Currency';
  }

  protected searchObjects(searchText: string): Observable<any[]> {
    if (!searchText) return of([]);
    return this.currencyService.currencies$.pipe(
      map(list => (list || []).filter(c => this.getObjectName(c).toLowerCase().includes(searchText.toLowerCase()))),
      catchError(() => of([]))
    );
  }

  public getObjectName(item: any): string {
    return item?.CurrencyName || item?.Name || item?.Description || '';
  }

  public getObjectId(item: any): number | null {
    return item?.CurrencyID ?? item?.ID ?? null;
  }
}
